import _get from 'lodash/get';
import _has from 'lodash/has';
import _isEmpty from 'lodash/isEmpty';
import _uniq from 'lodash/uniq';

export const getMatchedLabels = (item, matchedAudiences, matchedTags) => {
  const matches = [];

  if (_isEmpty(matchedAudiences) && _isEmpty(matchedTags)) return [];

  const audiences =
    _get(item, 'expandedAudience') || _get(item, 'audienceType', []);
  const tags = _get(item, 'expandedTags') || _get(item, 'tags', []);

  audiences.forEach(audience => {
    const match = matchedAudiences.filter(
      el => _get(el, 'id') && el.id === (audience || _get(audience, 'sys.id')),
    );
    if (match.length > 0) {
      matches.push(...match);
    }
  });
  tags.forEach(tag => {
    const match = matchedTags.filter(
      el => _get(el, 'id') && el.id === (tag || _get(tag, 'sys.id')),
    );
    if (match.length > 0) {
      matches.push(...match);
    }
  });

  return _uniq(
    matches.map(match => match.label).filter(match => Boolean(match)),
  );
};

export const getClientExclusiveLevel = (
  resource,
  clientShortName,
  clientGroupShortName,
) => {
  let clientsShortName = [];
  if (_has(resource, 'client')) {
    clientsShortName = _get(resource, 'client', [])
      .map(
        client => _get(client, 'fields.shortName') || _get(client, 'shortName'),
      )
      .filter(name => name !== 'none');
  } else if (_has(resource, 'fields.client')) {
    clientsShortName = _get(resource, 'fields.client', []).map(clientFields =>
      _get(clientFields, 'fields.shortName'),
    );
  } else if (_has(resource, 'fields.clients')) {
    clientsShortName = _get(resource, 'clients', []).filter(
      name => name !== 'none',
    );
  }

  if (clientsShortName.includes(clientShortName)) return 'Client';
  if (clientsShortName.includes(clientGroupShortName)) return 'Client Group';

  return null;
};
